import React, { useState, useEffect } from "react";
import "./irregularities_sat.css";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import { FaArrowLeft } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { Modal, Spinner } from "react-bootstrap";

function Irregularities_sat() {
  const [guia, setGuia] = useState("");
  const [busqueda, setBusqueda] = useState(false);
  const [fecha, setFecha] = useState("");
  const [dataGet, setDataGet] = useState("");
  const [irregularidades, setIrregularidades] = useState([]);
  const [irregularityType, setirregularityType] = useState([]);
  const [houseEscrito, setHouseEscrito] = useState("");
  const [sugerenciasHouse, setSugerenciasHouse] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errorIrregularityType, setErrorIrregularityType] = useState(false);
  const [errorDescription, setErrorDescription] = useState(false);

  const formatGuia = (value) => {
    let numbersOnly = value.replace(/\D/g, "");
    if (numbersOnly.length > 3) {
      return numbersOnly.slice(0, 3) + "-" + numbersOnly.slice(3);
    }

    return numbersOnly;
  };

  const handleInputGuiaChange = (event) => {
    setGuia(formatGuia(event.target.value));
  };

  const updateGuia = async () => {
    try {
      const master = guia;
      //Aqui loader
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_irregularities/getMaster`,
        { master },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code == 1) {
        setDataGet(res.data.data);
        const now = new Date();
        const formattedDate =
          `${now.getDate().toString().padStart(2, "0")}-` +
          `${(now.getMonth() + 1).toString().padStart(2, "0")}-` +
          `${now.getFullYear()} ` +
          `${now.getHours().toString().padStart(2, "0")}:` +
          `${now.getMinutes().toString().padStart(2, "0")}`;
        setFecha(formattedDate);
        setIrregularidades(res.data.data_irregularities);
        setirregularityType(res.data.irregularity_types);
        setBusqueda(true);
      } else {
        Swal.fire("Error", "Master no encontrada, favor de verificar", "error");
      }
      //Aqui loader
      setLoading(false);
    } catch (error) {
      //Aqui loader
      setLoading(false);
      Swal.fire("Error", "Error. Intente nuevamente", "error");
    }
  };

  const reinicio = () => {
    setGuia("");
    setFecha("");
    setDataGet("");
    setBusqueda(false);
  };

  const saveIrregularitie = async () => {
    const userData = localStorage.getItem("user");
    const user = JSON.parse(userData);
    setLoading(true);

    const irregularity_house =
      document.getElementById("irregularity_house").value;
    const irregularity_type =
      document.getElementById("irregularity_type").value;
    const irregularity_description = document.getElementById(
      "irregularity_description"
    ).value;

    // Resetear errores
    setErrorIrregularityType(false);
    setErrorDescription(false);

    let hasError = false;

    if (!irregularity_type) {
      setErrorIrregularityType(true);
      hasError = true;
    }

    if (!irregularity_description.trim()) {
      setErrorDescription(true);
      hasError = true;
    }

    if (hasError) {
      setLoading(false);
      return;
    }

    try {
      const updatedData = {
        irregularity_house: document.getElementById("irregularity_house").value,
        irregularity_type: document.getElementById("irregularity_type").value,
        irregularity_description: document.getElementById(
          "irregularity_description"
        ).value,
        irregularity_date: fecha,
        master_id: dataGet.id,
        // user_id: user.id
        user_id: 1,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_irregularities/create`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.status === 200) {
        Swal.fire("Creado", "El elemento se a creado exitosamente.", "success");
        document.getElementById("irregularity_house").value = "";
        document.getElementById("irregularity_type").value = "";
        document.getElementById("irregularity_description").value = "";
        setHouseEscrito("");
        updateGuia();
      } else {
        Swal.fire("Error", "Hubo un error al crear el elemento", "error");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const buscarHouse = async (event) => {
    const value = event.target.value;
    setHouseEscrito(value);
  
    if (value.length === 0) {
      setSugerenciasHouse([]);
      return;
    }

    const updatedData = {
      texthouse: value,
      master_id: dataGet.id,
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_irregularities/buscarHouse`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      const data = res.data?.data || [];
      setSugerenciasHouse(data);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  // Función para manejar cuando el input pierde el foco
  const handleBlur = () => {
    // Un pequeño retraso para permitir que el usuario haga clic en las sugerencias antes de que desaparezcan
    setTimeout(() => setIsFocused(false), 200);
  };

  // Asegurarse de que las sugerencias desaparezcan si el input pierde el foco o si se hace clic fuera
  const handleClickSuggestion = (item) => {
    setHouseEscrito(item.hbs);
    setSugerenciasHouse([]);
  };

  return (
    <>
      <Helmet>
        <title>Horus | Irregularidades SAT</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        {!busqueda && (
          <div className="row justify-content-center">
            <div className="col-6">
              <label>
                <b>Guía Master</b>
              </label>
              <input
                type="text"
                className="form-control mt-3"
                id="guia"
                value={guia}
                onChange={handleInputGuiaChange}
                autoComplete="off"
              />

              <div className="mt-3 d-flex justify-content-end">
                <button className="btnn" onClick={updateGuia}>
                  Buscar
                </button>
              </div>
            </div>
          </div>
        )}
        {busqueda && (
          <div className="row justify-content-center">
            <div className="col-md-12">
              <b className="c-pointer" onClick={reinicio}>
                <FaArrowLeft /> Regresar
              </b>
            </div>
            <div className="col-md-4 mt-3">
              <label className="bold">
                <b>Guía Master:</b> {guia}
              </label>
            </div>
            <div className="col-md-4 mt-3" style={{ position: "relative" }}>
              <label className="bold">
                <b>Guía House:</b>
              </label>
              <input
                id="irregularity_house"
                type="text"
                className="form-control mt-2"
                value={houseEscrito}
                onChange={(e) => {
                  buscarHouse(e);
                }}
                autoComplete="off"
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
             
              {/* Cuadro de sugerencias solo si hay sugerencias y el input está enfocado */}
              {isFocused && sugerenciasHouse.length > 0 && (
                <div
                  className="position-absolute w-100 z-3"
                  style={{
                    maxHeight: "150px",
                    overflowY: "auto",
                    border: "1px solid #ddd", // Borde gris suave
                    backgroundColor: "#fff", // Fondo blanco
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Sombra suave para el cuadro
                    borderRadius: "5px", // Bordes redondeados
                    marginTop: "5px", // Espacio entre el input y las sugerencias
                    zIndex: "10", // Asegura que se muestre encima de otros elementos
                  }}
                >
                  <ul className="list-group">
                    {sugerenciasHouse.map((item) => (
                      <li
                        key={item.hbs}
                        className="list-group-item list-group-item-action"
                        onClick={() => handleClickSuggestion(item)} // Selecciona la sugerencia
                        style={{
                          cursor: "pointer",
                          backgroundColor: "#fff", // Fondo blanco
                        }}
                      >
                        {item.hbs}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <div className="col-md-4 mt-3">
              <label className="bold">
                <b>Fecha:</b> {fecha}
              </label>
            </div>
            <div className="col-md-6 mt-3">
              <label className="bold">
                <b>Tipo de Irregularidad:</b>
              </label>
              <select
                id="irregularity_type"
                type="text"
                className="form-control mt-2"
                autoComplete="off"
                onChange={(e) => {
                  if (e.target.value) {
                    setErrorIrregularityType(false);
                  }
                }}
              >
                <option defaultValue value="">
                  Seleccione...
                </option>
                {irregularityType.length > 0 ? (
                  irregularityType.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))
                ) : (
                  <option disabled>Cargando tipos...</option>
                )}
              </select>

              {errorIrregularityType && (
                <small className="text-danger">Este campo es obligatorio</small>
              )}
            </div>
            <div className="col-md-6 mt-3">
              <label className="bold">
                <b>Descripción Irregularidad:</b>
              </label>
              <textarea
                id="irregularity_description"
                type="text"
                className="form-control mt-2"
                autoComplete="off"
                onChange={(e) => {
                  if (e.target.value) {
                    setErrorDescription(false);
                  }
                }}
              ></textarea>
              {errorDescription && (
                <small className="text-danger">Este campo es obligatorio</small>
              )}
            </div>
            <div className="col-md-12 text-end mt-3">
              <button className="btnn" onClick={saveIrregularitie}>
                Guardar
              </button>
            </div>
            <div className="col-md-12 mt-3">
              <div className="table-responsive">
                <table className="table">
                  <thead className="text-center">
                    <tr>
                      <th className="table-capture-thead">Fecha</th>
                      <th className="table-capture-thead">House</th>
                      <th className="table-capture-thead">
                        Tipo de Irregularidad
                      </th>
                      <th className="table-capture-thead">Observaciones</th>
                      <th className="table-capture-thead">Usuario</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {irregularidades.length > 0 ? (
                      irregularidades.map((item) => (
                        <tr key={item.id}>
                          <th className="">
                            {item.date
                              ? (() => {
                                // Forzamos formato compatible si viene como string MySQL
                                const fixedFecha = item.date.replace(
                                  " ",
                                  "T"
                                ); // ej. "2024-04-23 14:13:00" => "2024-04-23T14:13:00"
                                const fechaObj = new Date(fixedFecha);

                                if (isNaN(fechaObj)) return "Fecha inválida";

                                const dia = fechaObj
                                  .getDate()
                                  .toString()
                                  .padStart(2, "0");
                                const mes = (fechaObj.getMonth() + 1)
                                  .toString()
                                  .padStart(2, "0");
                                const año = fechaObj.getFullYear();
                                const hora = fechaObj
                                  .getHours()
                                  .toString()
                                  .padStart(2, "0");
                                const minutos = fechaObj
                                  .getMinutes()
                                  .toString()
                                  .padStart(2, "0");

                                return `${dia}/${mes}/${año} ${hora}:${minutos}`;
                              })()
                              : "Sin fecha"}
                          </th>
                          <th className="">{item.house}</th>
                          <th className="">{item.irregularity_type}</th>
                          <th className="">{item.description}</th>
                          <th className="">{item.user}</th>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5">No se encontrarón irregularidades</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default Irregularities_sat;
